import { celsius_to_fahrenheit } from 'src/helpers/interface_helpers';
import { home_data, user_settings } from 'src/stores/account/user';
import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
import { formatTitleToSnakeCase } from 'src/helpers/utilities';

export const dashboardWeatherItem = (type, weatherStore, data) => {
	let temperature, temperaturePrefix;

	const [windSpeed, windUnit] = weatherStore.wind.split(' ');
	const windText = `${windSpeed} ${windUnit}`;

	if (get(home_data).weather_temp_unit === 'F') {
		temperature = `${celsius_to_fahrenheit(weatherStore?.temperature.split('°')[0]) || 0}°`;
		temperaturePrefix = 'F';
	} else {
		temperature = weatherStore?.temperature;
		temperaturePrefix = 'C';
	}

	return {
		image: `./images/weather/${weatherStore.image}`,
		temperature: temperature,
		temperaturePrefix: temperaturePrefix,
		icon: weatherStore.icon,
		type: get(format)(`weather_widget_type_${formatTitleToSnakeCase(weatherStore.type)}`, {
			default: weatherStore.type,
		}),
		details: [
			{
				title: get(format)('weather_widget_humidity', { default: 'Humidity ' }),
				text: `${weatherStore.humidity}`,
			},
			{
				title: get(format)('weather_widget_wind', { default: 'Wind' }),
				text: windText,
			},
			{
				title: get(format)('weather_widget_station', {
					default: 'Weather Station',
				}),
				text: `${get(user_settings).weather_station?.data?.stationName}`,
			},
		],
		_type: type,
		position: data.position,
		id: data.id || 'wc-0',
		name: get(format)('dashboard_weather_widget_card', {
			default: 'Weather Widget',
		}),
	};
};
